/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from 'react-stripe-elements';
import { Container, Row, Col } from 'react-bootstrap';
import error from '../images/rename.png';
import countries from '../data/countries.json';

const PayWithCard = (props) => {
  const {
    handleStateChange,
    handleCreditCardEntered,
    email,
    country,
    zipCode,
    invalidFontColorZip,
    invalidFontColorEmail,
    formErrors,
    labelCountry,
    labelStripeCard,
  } = props;
  const [ccValid, setCcValid] = useState(false);
  const [ccTouched, setCcTouched] = useState(false);
  const [expDateValid, setExpDateValid] = useState(false);
  const [expDateTouched, setExpDateTouched] = useState(false);
  const [cvcValid, setCvcValid] = useState(false);
  const [cvcTouched, setCvcTouched] = useState(false);

  const cardBrandToPfClass = {
    visa: 'pf-visa',
    mastercard: 'pf-mastercard',
    amex: 'pf-american-express',
    discover: 'pf-discover',
    diners: 'pf-diners',
    jcb: 'pf-jcb',
    unknown: 'pf-credit-card'
  };

  useEffect(() => {
    if (ccValid && expDateValid && cvcValid) {
      handleCreditCardEntered(true);
    } else {
      handleCreditCardEntered(false);
    }
  }, [ccValid, expDateValid, cvcValid]);

  const setBrandIcon = (brand) => {
    const brandIconElement = document.getElementById('brand-icon');
    let pfClass = 'pf-credit-card';
    if (brand in cardBrandToPfClass) {
      pfClass = cardBrandToPfClass[brand];
    }
    for (let i = brandIconElement.classList.length - 1; i >= 0; i--) {
      brandIconElement.classList.remove(brandIconElement.classList[i]);
    }
    brandIconElement.classList.add('pf');
    brandIconElement.classList.add(pfClass);
  }

  const changeCCIcon = (e) => {
    setBrandIcon(e.brand);
  };

  return (
    <>
      <div className="form-group">
        <label className="inputLabel" style={{ display: 'none' }}>Email</label>
        <input
          className={`input-group my-1 p-1 border ${invalidFontColorEmail}`}
          value={email}
          placeholder="Email"
          name="email"
          onChange={(e) => handleStateChange(e)}
          style={{ display: 'none' }}
        />
        <span style={formErrors.email.length > 0 ? { display: 'inline', color: 'red' } : { display: 'none' }}>
          <img alt="error" src={error} />
          {formErrors.email}
        </span>        
        <div className="invalid-feedback">Please provide a valid email.</div>
      </div>
      <div className="form-group" style={{ marginBottom: 0, borderBottom: 0 }}>
        <label className="inputLabel">{labelStripeCard}</label>
        <div className="div-card-number">
          <CardNumberElement
            name="test"
            className="p-2 card-element-input hide-text"
            placeholder="**** **** **** ****"
            onBlur={(e) => setCcTouched(true)}
            onChange={(e) => {
              changeCCIcon(e);
              e.elementType === 'cardNumber' && e.complete
                ? setCcValid(true)
                : setCcValid(false);
            }}
          />
          <span className="brand">
            <i className="pf pf-credit-card" id="brand-icon" />
          </span>
        </div>
        <span style={!ccValid && ccTouched ? { display: 'inline', color: 'red' } : { display: 'none' }}>
          <img alt="error" src={error} />
          The credit card number is not valid
        </span>
      </div>
      <Container>
        <Row>
          <Col className="p-0">
            <CardExpiryElement
              className="p-2 border"
              onBlur={(e) => setExpDateTouched(true)}
              onChange={(e) => {
                (e.elementType === 'cardExpiry' && e.complete
                  ? setExpDateValid(true)
                  : setExpDateValid(false))
              }}
            />
            <span style={!expDateValid && expDateTouched ? { display: 'inline', color: 'red' } : { display: 'none' }}>
                <img alt="error" src={error} />
                The expiration date is not valid.
            </span>            
          </Col>
          <Col className="p-0">
            <CardCVCElement
              className="p-2 border input-standard"
              onBlur={(e) => setCvcTouched(true)}
              onChange={(e) => {
                (e.elementType === 'cardCvc' && e.complete
                  ? setCvcValid(true)
                  : setCvcValid(false))
              }}
            />
            <span style={!cvcValid && cvcTouched ? { display: 'inline', color: 'red' } : { display: 'none' }}>
                <img alt="error" src={error} />
                The CVC number is not valid.
            </span>
          </Col>
        </Row>
      </Container>
      <div className="form-group">
        <label className="inputLabel">{labelCountry}</label>
        <select name="country" className="form-control" onChange={handleStateChange} value={country}>
          {countries.map((country) => (
            <option key={country.name}>{country.name}</option>
          ))}
        </select>
        <i className="fa fa-chevron-down" />
        <input
          type="text"
          className={`input-group p-1 border ${invalidFontColorZip}`}
          value={zipCode}
          name="zipCode"
          placeholder="ZIP"
          onChange={(e) => handleStateChange(e)}
        />
        <span style={formErrors.zipCode.length > 0 ? { display: 'inline', color: 'red' } : { display: 'none' }}>
          <img alt="error" src={error} />
          {formErrors.zipCode}
        </span>
      </div>
    </>
  );
}

export default PayWithCard;
